import {
  buildSerializer,
  buildDeserializer,
  SerializeMap,
} from "lib/serializerUtils";

const saleStatusSerializeMap: SerializeMap<SaleStatus> = {
  id: "id",
  name: "name",
  archetype: "archetype",
  saleType: "sale_type",
  created: "created",
  lastModified: "last_modified",
  permissions: "permissions",
};

export const serializeSaleStatus = buildSerializer(
  saleStatusSerializeMap,
  "saleStatus",
);

export const deserializeSaleStatus = buildDeserializer<SaleStatus>(
  saleStatusSerializeMap,
  "saleStatus",
);
